import { toCurrency } from 'to-words';

const getLocaleForNumbering = (numberingSystem) => {
  return numberingSystem === 'international' ? 'en-US' : 'en-IN';
};

const currencyWordOptionsByCode = {
  INR: {
    name: 'Rupee',
    plural: 'Rupees',
    symbol: 'Rs.',
    fractionalUnit: {
      name: 'Paisa',
      plural: 'Paise',
      symbol: ''
    }
  },
  USD: {
    name: 'Dollar',
    plural: 'Dollars',
    symbol: '$',
    fractionalUnit: {
      name: 'Cent',
      plural: 'Cents',
      symbol: ''
    }
  },
  EUR: {
    name: 'Euro',
    plural: 'Euros',
    symbol: 'EUR',
    fractionalUnit: {
      name: 'Cent',
      plural: 'Cents',
      symbol: ''
    }
  },
  GBP: {
    name: 'Pound',
    plural: 'Pounds',
    symbol: 'GBP',
    fractionalUnit: {
      name: 'Penny',
      plural: 'Pence',
      symbol: ''
    }
  },
  AED: {
    name: 'Dirham',
    plural: 'Dirhams',
    symbol: 'AED',
    fractionalUnit: {
      name: 'Fils',
      plural: 'Fils',
      symbol: ''
    }
  }
};

export const getNumberingSystemFromStorage = () => {
  if (typeof window === 'undefined') {
    return 'indian';
  }
  return window.localStorage.getItem('numberingSystem') || 'indian';
};

export const getCurrencyPrefixFromStorage = () => {
  if (typeof window === 'undefined') {
    return 'Rs.';
  }
  return window.localStorage.getItem('currencyPrefix') || 'Rs.';
};

export const getCurrencyCodeFromStorage = () => {
  if (typeof window === 'undefined') {
    return 'INR';
  }
  return window.localStorage.getItem('currencyCode') || 'INR';
};

export const formatNumber = (value, numberingSystem, options = {}) => {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return 'N/A';
  }

  const locale = getLocaleForNumbering(numberingSystem);
  const minimumFractionDigits = options.minimumFractionDigits ?? 2;
  const maximumFractionDigits = options.maximumFractionDigits ?? 2;

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits,
    maximumFractionDigits
  }).format(value);
};

export const formatCurrency = (value, numberingSystem, options = {}) => {
  const prefix = options.prefix ?? 'Rs.';
  const formatted = formatNumber(value, numberingSystem, {
    minimumFractionDigits: options.minimumFractionDigits ?? 2,
    maximumFractionDigits: options.maximumFractionDigits ?? 2
  });

  if (formatted === 'N/A') {
    return formatted;
  }

  return `${prefix}${formatted}`;
};

export const formatAmountInWords = (value, numberingSystem, options = {}) => {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return 'N/A';
  }

  const currencyCode = String(options.currencyCode || 'INR').toUpperCase();
  const localeCode = getLocaleForNumbering(numberingSystem);

  return toCurrency(value, {
    localeCode,
    ignoreDecimal: options.ignoreDecimal ?? false,
    doNotAddOnly: options.doNotAddOnly ?? false,
    currencyOptions: currencyWordOptionsByCode[currencyCode] || currencyWordOptionsByCode.INR
  });
};
